export const SET_ITEM = 'SET_ITEM';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const POST_ITEM = 'POST_ITEM';
export const GET_ITEM_RELATED_FAILURE = 'GET_ITEM_RELATED_FAILURE';
export const GET_ITEM_RELATED_SUCCESS = 'GET_ITEM_RELATED_SUCCESS';
export const GET_ALL_ITEMS_FAILURE = 'GET_ALL_ITEMS_FAILURE';
export const GET_ALL_ITEMS_SUCCESS = 'GET_ALL_ITEMS_SUCCESS';
export const RESET_ITEM_STATUS = 'RESET_ITEM_STATUS';

